export default {
  integration: {
    groupBuying: {
      storeBindings: 'Store bindings',
      notAvailable: 'Not available yet',
      title: 'Group Buying',
      overview: 'Channel Overview',
      products: 'Group Buying Products',
      history: 'Voucher Redemption Records',
      historyNoAccess: 'You do not have permission to view redemption records. Contact your administrator to request access, then sign in again.',
      data: 'Group Buying Data',
      overviewUnavailable: 'Channel overview is not available yet. Manage authorized accounts in Channel Management.',
      mappingDescription: 'Manage links between your stores and platform stores.',
      mappingUnavailable: 'Store binding for {platform} is not available yet.',
      productsUnavailable: 'Group buying product management is not available yet.',
    },
    connections: {
      authorizationTarget: 'Authorization target',
      storeAuthorization: 'Store authorization',
      meituanStoreGuide: 'Use a Meituan account permitted to manage this store to authorize voucher verification. Link the store in ZhiJie before using store business features.',
      storeAuthorizationUnavailable: 'Meituan store authorization is not available in the current service version. Contact your administrator to upgrade.',
      meituanPlatformRevokeGuide: 'This action does not revoke the authorization on Meituan. To revoke it, go to the Meituan merchant portal and review the scope shown there.',
      startAuthorization: 'Start authorization',
      requestedBusinesses: 'Requested businesses',
      noSession: 'No authorization started. Select businesses to generate an authorization entry.',
      pendingSessionHint: 'Complete authorization on the platform, then check the result. Do not start another request before the result is confirmed.',
      latestAuthorization: 'Latest authorization',
      authorizationDetails: 'Authorization details',
      authorizationProgressStates: { pending: 'Awaiting authorization', unknown: 'Result unconfirmed', issue: 'Authorization issue' },
      viewAuthorizationDetails: 'View details',
      loadingAuthorizationProgress: 'Loading authorization progress…',
      authorizationRecordUnavailableHint: 'This authorization record is no longer available. Check the account’s authorization status in the list below.',
      bindProductsInCatalog: 'Go to “Group buying products”',
      platformSteps: {
        MEITUAN: {
          start: 'Generate a store authorization link. Once authorization is complete, you can authorize additional Meituan stores.',
          confirmTitle: 'Store authorization',
          confirm: 'Authorize with a Meituan account that can manage this store; return here to "Check authorization result" if needed.',
        },
        DOUYIN: {
          start: 'Generate an authorization link for the Douyin merchant account.',
          confirmTitle: 'Account authorization',
          confirm: 'Authorize with a Douyin account that can manage this store; return here to "Check authorization result" if needed.',
        },
        KUAISHOU: {
          start: 'Enter the Kuaishou merchant ID and name, submit the application and contact operations.',
          confirmTitle: 'Complete authorization',
          confirm: 'After operations processes the request, authorize with the merchant account in Kuaishou Merchant Center; return here to "Check authorization result" if needed.',
        },
      },
      sessionPartial: 'Partially completed. Confirmed authorizations remain valid.',
      upgradeRequired: 'This server version does not support unified authorization. Contact your administrator to upgrade.',
      authorizedAccounts: '{platform} authorized accounts',
      noAuthorizedAccounts: 'No authorized {platform} accounts',
      generateLink: 'Generate authorization link',
      submitApplication: 'Submit application',
      cancelApplication: 'Cancel application',
      cancelApplicationConfirm: 'This only ends this application in ZhiJie. It does not revoke Kuaishou authorization. Resolve the previous application or authorization in Kuaishou before applying again with the correct merchant ID. Continue?',
      applicationCancelled: 'Cancelled',
      cancelledNextStep: 'This ZhiJie application has ended. Resolve the previous Kuaishou application or authorization, then start again with the correct merchant ID.',
      cancelApplicationProcessing: 'Callback processing has started or the application has changed. Cancellation is unavailable; check the authorization result.',
      cancelApplicationUnknown: 'The cancellation result is unknown. Check the authorization result or retry cancellation.',
      kuaishouUserIdHelp: 'Enter the Kuaishou Life Service merchant ID. Operations enters the main account Kuaishou user ID when initiating authorization in Kuaishou.',
      collapseOperation: 'Collapse',
      preparationReady: 'Ready. Continue to authorize the brand.',
      manageAccountHint: 'Add a business or reauthorize using the account list below.',
      kuaishouUserId: 'Kuaishou merchant ID',
      kuaishouUserIdInvalid: 'Enter a numeric Kuaishou merchant ID.',
      kuaishouMerchantName: 'Merchant name',
      kuaishouMerchantNameInvalid: 'Enter a merchant name of up to 100 characters.',
      kuaishouMerchantNameHelp: 'Enter a recognizable merchant name to display in the authorized account list.',
      manualAuthorizationGuide: 'Submit your merchant ID and contact operations. Once they verify ownership and initiate the request in Kuaishou using the main account user ID, authorize in Kuaishou Merchant Center under Store management → App authorization. The account is linked automatically; return here to check the result.',
      applicationExpires: 'Valid until {expires}',
      authorizationGuide: '{platform} authorization guide',
      authorizedBusinesses: 'Authorized businesses and status',
      accountId: 'Account ID',
      singleAccountHint: 'To switch accounts, disconnect the current account first.',
      sameAccountBusiness: 'Authorize the additional business with this account. Adding a business does not switch accounts.',
      reauthorizeHint: 'Reauthorize to restore access',
      guideSteps: {
        authorize: { title: 'Generate authorization link', description: 'Select the business to enable and generate a link to authorize on the platform.' },
        merchant: { title: 'Enter merchant details', description: 'Enter the Kuaishou Life Service merchant ID to submit an authorization application.' },
        result: { title: 'Brand authorization', description: 'Confirm access using a platform administrator account, then check the result here.' },
        stores: { title: 'Store binding', description: 'Match ZhiJie stores with platform stores.' },
        products: { title: 'Redemption configuration', description: 'Configure the redemption product and redemption units for each platform product.' },
      },
      business: 'Business / solution',
      businessUnknown: 'Business not specified',
      addBusiness: 'Add business',
      businesses: { KUAISHOU_GROUP_BUY: 'Group buying', MEITUAN_58: 'Voucher verification', DOUYIN_16: 'Local services group buying', DOUYIN_21: 'Restaurant group buying' },
      reauthorize: 'Reauthorize',
      appendScope: 'Reauthorize using the current account to update its authorization status.',
      apiPermissions: 'API permissions',
      permissionsHint: 'Permissions apply only to authorized resources and reflect the latest synced result. Granted permissions do not mean the corresponding features are available.',
      permissionsUnavailable: 'Currently unavailable',
      permissionsEmpty: 'No API permissions available',
      permissionsMissing: 'Permission information not provided',
      permissionNames: {
        DOUYIN: { 1: 'Store management', 16: 'Merchant authorization', 139: 'Voucher verification', 140: 'Verification reconciliation', 144: 'Product lookup', 175: 'Restaurant voucher verification', 176: 'Restaurant verification reconciliation', 180: 'Restaurant product lookup' },
        MEITUAN: { tuangou: 'Group buying', shangpin: 'Product management' },
      },
      restoreScope: 'Use the original account to authorize this business again. Only the scope confirmed this time will be restored.',
      queryAuthorization: 'Check authorization result',
      restoreConnection: 'Restore connection',
      chooseRestoreAccount: 'Select the original account below to restore its connection.',
      linkOtherAccount: 'Connect another account',
      connectionState: 'Connection status',
      businessNotOpen: 'Not available in this version',
      douyinManageAccountHint: 'Reauthorize or disconnect the account using its row below.',
      authorizationResultUnknown: 'The authorization request result is unknown. Check the original request before continuing.',
      douyinDisconnectUnknown: 'The disconnection result is unknown. The last confirmed state is shown. Check the authorization result before continuing.',
      douyinResultGuide: 'Check authorization results received by the cloud and account connections. This does not query Douyin permissions in real time.',
      connectionSyncPending: 'Authorization succeeded. Account connection details are syncing.',
      title: 'Channel Management',
      description: 'Manage platform accounts, business access and store bindings.',
      noAccess: 'You do not have permission to view Channel Management. Contact your administrator to request access, then sign in again.',
      addAuthorization: 'Add authorization',
      goAuthorize: 'Authorize on platform',
      authorizationUnavailable: 'Authorization for {platform} is not available yet.',
      authorizationReady: '{platform} authorization is available. Select a business.',
      capabilityUnknown: 'Authorization is temporarily unavailable for this business. Refresh the page and try again.',
      capabilityLoadFailed: 'Authorization is temporarily unavailable. Refresh the page and try again.',
      recoverAuthorization: 'Recover authorization result',
      awaitingList: 'Authorization completed. If the account is not listed yet, refresh the list shortly.',
      capabilityReasons: {
        MANUAL_STATE_UNVERIFIED: 'Kuaishou manual authorization is not enabled. Contact your administrator.',
        ENTRY_UNAVAILABLE: 'The authorization entry address is not configured. Contact your administrator.',
        PROVIDER_UNAVAILABLE: 'Platform authorization is not configured. Contact your administrator.',
        BUSINESS_UNAVAILABLE: 'Authorization permissions for this business are not configured. Contact your administrator.',
      },
      guides: {
        MEITUAN: 'Authorize a Meituan local services merchant account for group buying stores and voucher verification.',
        DOUYIN: 'Authorize a Douyin life services merchant account for group buying stores and voucher verification.',
        KUAISHOU: 'Authorize a Kuaishou merchant account for group buying stores and voucher verification.',
      },
      platform: 'Platform',
      account: 'Merchant account',
      authorizationStatus: 'Authorization status',
      actions: 'Actions',
      reload: 'Refresh list',
      refresh: 'Check current status',
      refreshAccountInfo: 'Refresh account info',
      accountInfoRefreshed: 'Account information updated',
      accountInfoUnavailable: 'No matching account name was returned. The previous information has been kept.',
      accountInfoRefreshFailed: 'Could not refresh account information. The previous information has been kept. Please try again later.',
      accountInfoRequiresAuthorization: 'An active connection and valid authorization are required.',
      accountInfoRequiresShopPermission: 'The store management API permission is required.',
      accountInfoRequiresUpgrade: 'This service version does not support account information refresh. Ask your administrator to upgrade.',
      disconnect: 'Disconnect account',
      disconnectTitle: 'Confirm disconnection?',
      disconnectEffects: {
        MEITUAN: {
          message: 'Disconnecting will {business} in this system. Any reauthorization in progress will also be {requests}.',
          business: 'disable the related businesses under this authorization',
          requests: 'cancelled',
        },
        DOUYIN: {
          message: 'Disconnecting will {business} in this system. This brand’s pending Douyin authorization requests will also be {requests}.',
          business: 'disable all businesses under this account',
          requests: 'cancelled',
        },
        KUAISHOU: {
          message: 'Disconnecting will {business} in this system. This brand’s pending Kuaishou authorization requests will also be {requests}. Related business notifications will not be reassigned automatically.',
          business: 'disable all businesses under this account',
          requests: 'cancelled',
        },
      },
      disconnectCurrentBrand: 'Confirm disconnect',
      platformRevokeGuide:
        'This action does not revoke the authorization on {platform}. To revoke it, go to the platform merchant portal and review the scope shown there.',
      platformPortalLinks: {
        MEITUAN: 'Open Meituan Jingyingbao',
        DOUYIN: 'Open Douyin Laike',
        KUAISHOU: 'Open Kuaishou Merchant Center',
      },
      loadFailed: 'Could not load authorizations. Refresh the list to try again. Any existing entries are from the previous load.',
      refreshFailed: 'Could not check the current status. The last confirmed status is shown. Please try again.',
      retryAfterQuery: 'The current status was checked and the authorization has not been removed. Confirm again to remove it.',
      unknownResult:
        'The authorization removal could not be confirmed. The last confirmed status is shown. Check the current status before trying again.',
      platforms: {
        DOUYIN: 'Douyin',
        MEITUAN: 'Meituan',
        KUAISHOU: 'Kuaishou',
      },
      states: {
        DISCONNECTED: 'Removed',
        AUTHORIZED: 'Authorized',
        REVOKED: 'Revoked',
        INVALID: 'Invalid',
      },
    },
    pageTitle: 'Channel Management',
    pageDesc: 'Manage mini program authorizations and versions.',

    wechatCardTitle: 'WeChat Mini Program',
    douyinCardTitle: 'Douyin Mini Program',
    alipayCardTitle: 'Alipay Mini Program',
    unionPayCardTitle: 'UnionPay Mini Program',
    xiaohongshuCardTitle: 'RED Mini Program',
    harmonyCardTitle: 'HarmonyOS Meta Service',
    notAuthorized: 'Not authorized yet',
    notAuthorizedShort: 'Unauthorized',
    notAuthorizedDesc: 'After authorization, the mini program can use your brand stores, products, and membership services.',
    douyinDesc: 'Click Authorize and follow the Douyin page instructions to complete binding.',
    waitingAuthorization: 'Pending',
    noMiniProgramTip: 'No mini program?',
    registerNow: 'Register',
    customize: 'Customize Mini Program',
    customizeDesc: 'Customize your mini program’s page layout and content.',
    customizeAuthorizedDesc:
      'Arrange page layouts, configure image carousels, product displays, and navigation to create a mini program that reflects your brand.',
    authorizeNow: 'Authorize',
    scanToVisit: 'Scan with WeChat to visit',
    qrCodeAlt: 'WeChat Mini Program Code',
    qrCodeUnavailable: 'Mini program code unavailable',
    qrCodeUnavailableDesc: 'The mini program code is not available yet. Refresh it to try again.',
    refreshQrCode: 'Refresh Code',
    refreshQrCodeSuccess: 'Mini program code refreshed',
    downloadQrCode: 'Download Mini Program Code',
    downloadQrCodeSuccess: 'Mini program code downloaded',
    downloadQrCodeFailed: 'Failed to download the mini program code. Please try again.',

    appName: 'Mini Program Name',
    externalAppId: 'Mini Program AppID',
    principalName: 'Principal Name',
    miniProgramIntroduction: 'Mini Program Description',
    authorizationId: 'Authorization ID',
    status: 'Authorization Status',
    revision: 'Revision',
    lastSyncedTime: 'Last Synced Time',

    statusAuthorized: 'Authorized',
    statusRevoked: 'Revoked',
    statusInvalid: 'Invalid',

    startAuth: 'Start Authorization',
    reAuth: 'Re-authorize Current Mini Program',
    refreshMirror: 'Refresh Status',
    refreshSuccess: 'Authorization status refreshed',
    refreshRemoteMissing: 'No valid authorization found. Please confirm authorization is complete.',
    deauthorizationGuide: 'Deauthorization Guide',
    deauthorizationGuideTitle: 'Deauthorize WeChat Mini Program',
    deauthorizationGuideNotice: 'WeChat requires the mini program administrator to deauthorize it in WeChat Official Accounts Platform.',
    deauthorizationGuideStep1: 'Sign in to WeChat Official Accounts Platform with the mini program administrator account.',
    deauthorizationGuideStep2: 'Go to Settings → Third-Party Settings.',
    deauthorizationGuideStep3: 'Find the authorized third-party platform and follow the page instructions to deauthorize it.',
    deauthorizationGuideResult: 'After completion, the authorization status will automatically become Revoked.',
    openWechatPublicPlatform: 'Open WeChat Platform',

    manageMiniProgram: 'Manage Mini Program',
    managePageTitle: 'Manage Mini Program',
    managePageDesc: 'View WeChat Mini Program authorization information, and submit or release mini program versions.',
    basicInfoTitle: 'Basic Information',
    basicInfoDesc: 'Current authorized mini program information.',
    refreshBasicInfo: 'Refresh Basic Information',
    refreshBasicInfoSuccess: 'Basic information refreshed',
    authorizationPlatform: 'Authorization Platform',
    noAuthorizedMiniProgram: 'No authorized mini program information',
    versionInfoTitle: 'Version Management',
    versionInfoDesc: 'After submission, the system uploads the latest mini program version and sends it to WeChat for review.',
    queryAuditStatus: 'Query Review Status',
    queryAuditStatusSuccess: 'Review status updated',
    versionOperationResultUnknown: 'The result could not be confirmed. Query the latest status first.',
    versionOperationRetryAvailable: 'A new result has not been confirmed. Query again or retry the original operation.',
    queryOperationStatus: 'Query Latest Status',
    retrySubmitVersion: 'Retry Submission',
    retryReleaseVersion: 'Retry Release',
    reload: 'Reload',
    authorizationLoadFailed: 'Failed to load authorization information',
    authorizationRefreshFailed: 'Authorization refresh failed. Previously loaded information is shown.',
    versionLoadFailed: 'Failed to load version information',
    versionRefreshFailed: 'Version refresh failed. Previously loaded information is shown.',
    qrCodeLoadFailed: 'Failed to load the mini program code. Refresh to retry.',
    qrCodeRefreshFailed: 'Code refresh failed. The previously loaded code is shown.',
    latestVersionLoadFailed: 'Failed to query the latest version. Please retry.',
    versionOperationFailed: 'Version operation failed',
    versionFailureNextStep: 'Resolve the reported issue, then continue with an available action above.',
    versionInformationUnavailable: 'No version information available',
    viewAuthorizationProgress: 'View Authorization Progress',
    authorizationPollingFailed: 'Unable to retrieve authorization progress. Retrying.',
    authorizationCloseHint: 'You can continue authorization on the platform after closing this window, then return to view progress.',
    authorizationEntryUnavailable: 'The authorization entry is unavailable. Close this window and check progress again.',
    submitNewVersion: 'Submit New Version',
    releaseVersion: 'Release',
    submitVersionConfirm: 'Submit a new mini program version to WeChat for review?',
    releaseVersionConfirm: 'Release this approved mini program version?',
    submitVersionSuccess: 'New version task submitted',
    releaseVersionSuccess: 'Release task submitted',
    noVersionTask: 'No version task',
    noVersionTaskDesc: 'No submission records yet. Submit a new version to view review progress here.',
    reviewProgressTitle: 'Version Review Progress',
    reviewStepSubmit: 'Submit for Review',
    reviewStepWechat: 'WeChat Review',
    reviewStepResult: 'Review Result',
    reviewPassed: 'Approved',
    reviewTipPending:
      'After submitting for review, you can check the status on this page. WeChat usually completes reviews within 3–4 business days; the final result is subject to WeChat.',
    reviewTipReviewing:
      'WeChat usually completes reviews within 3–4 business days. This submission is still within the normal review period. Query the review status for updates.',
    reviewTipOverdue: 'This review has exceeded 4 business days. Please refer to the WeChat review result and query the review status.',
    reviewTipPassed: 'The latest version has passed WeChat review and can now be released.',
    currentOnlineVersion: 'Current Online Version',
    onlineReleaseTime: 'Last Release Time',
    latestAvailableVersion: 'Latest Open Platform Version',
    latestVersionNotFetched: 'Not retrieved',
    getLatestVersion: 'Get Latest Version',
    getLatestVersionSuccess: 'Latest version retrieved',
    checkingUpgradeAvailability: 'Checking for a new version',
    alreadyLatestVersion: 'The current version is up to date',
    taskTemplateVersion: 'Last Submitted Version',
    versionStatus: 'Version Status',
    submittedTime: 'Last Review Submission Time',
    statusSubmitting: 'Submitting new version',
    statusUnderReview: 'Under WeChat review',
    statusReviewRejected: 'Review rejected',
    statusReadyToRelease: 'Approved, ready to release',
    statusReleasing: 'Releasing',
    statusReleaseFailed: 'Release failed, ready to retry',
    statusReleased: 'Released',
    statusFailed: 'Version operation failed',

    authDialogTitle: 'Complete Authorization',
    authDialogTip:
      'Sign in with the platform administrator account in the new page and complete authorization. If no page appears, use the button below to open it again.',
    authEntryExpireAt: 'Complete authorization before',
    openEntryUrl: 'Open Authorization Page',

    sessionStatus: 'Session Status',
    sessionPending: 'Waiting for authorization…',
    sessionAuthorized: 'Authorization succeeded',
    sessionFailed: 'Authorization failed',
    sessionExpired: 'The authorization link has expired.',
    failureReason: 'Failure Reason',
    createSessionFail: 'Failed to open the authorization page. Please try again later.',
    sessionRecoveryUnavailable: 'The original authorization session was not found or has expired. Click Authorize again to start a new session.',
    done: 'Done',
  },
};
